var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAndriodPlatformIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8952 26.913C30.8876 26.913 36.5561 21.6805 36.5561 15.226C36.5561 8.77149 30.8876 3.53906 23.8952 3.53906C16.9028 3.53906 11.2344 8.77149 11.2344 15.226C11.2344 21.6805 16.9028 26.913 23.8952 26.913Z",
    fill: "#A4C639"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4952 12.3047H14.2952C12.6048 12.3047 11.2344 13.6751 11.2344 15.3656V34.5656C11.2344 36.256 12.6048 37.6264 14.2952 37.6264H33.4952C35.1857 37.6264 36.5561 36.256 36.5561 34.5656V15.3656C36.5561 13.6751 35.1857 12.3047 33.4952 12.3047Z",
    fill: "#A4C639"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2471 1.66783C15.005 1.231 15.1628 0.680578 15.5997 0.438436C16.0365 0.196295 16.5869 0.354125 16.8291 0.790961L21.753 9.67406C21.9952 10.1109 21.8374 10.6613 21.4005 10.9035C20.9637 11.1456 20.4133 10.9878 20.1711 10.5509L15.2471 1.66783Z",
    fill: "#A4C639"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1128 18.5657C37.1128 16.7215 38.6077 15.2266 40.4519 15.2266C42.296 15.2266 43.791 16.7215 43.791 18.5657V30.3918C43.791 32.2359 42.296 33.7309 40.4519 33.7309C38.6077 33.7309 37.1128 32.2359 37.1128 30.3918V18.5657Z",
    fill: "#A4C639"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2866 32.0579C25.2866 30.2137 26.7816 28.7188 28.6257 28.7188C30.4699 28.7188 31.9648 30.2137 31.9648 32.0579V43.884C31.9648 45.7281 30.4699 47.2231 28.6257 47.2231C26.7816 47.2231 25.2866 45.7281 25.2866 43.884V32.0579Z",
    fill: "#A4C639"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5439 1.66783C32.786 1.231 32.6282 0.680578 32.1914 0.438436C31.7545 0.196295 31.2041 0.354125 30.962 0.790961L26.038 9.67406C25.7958 10.1109 25.9537 10.6613 26.3905 10.9035C26.8273 11.1456 27.3778 10.9878 27.6199 10.5509L32.5439 1.66783Z",
    fill: "#A4C639"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6783 18.5657C10.6783 16.7215 9.18328 15.2266 7.33913 15.2266C5.49498 15.2266 4 16.7215 4 18.5657V30.3918C4 32.2359 5.49498 33.7309 7.33913 33.7309C9.18328 33.7309 10.6783 32.2359 10.6783 30.3918V18.5657Z",
    fill: "#A4C639"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5044 32.0579C22.5044 30.2137 21.0095 28.7188 19.1653 28.7188C17.3212 28.7188 15.8262 30.2137 15.8262 32.0579V43.884C15.8262 45.7281 17.3212 47.2231 19.1653 47.2231C21.0095 47.2231 22.5044 45.7281 22.5044 43.884V32.0579Z",
    fill: "#A4C639"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8952 26.913C30.8876 26.913 36.5561 21.6805 36.5561 15.226C36.5561 8.77149 30.8876 3.53906 23.8952 3.53906C16.9028 3.53906 11.2344 8.77149 11.2344 15.226C11.2344 21.6805 16.9028 26.913 23.8952 26.913Z",
    fill: "#A4C639"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4952 12.3047H14.2952C12.6048 12.3047 11.2344 13.6751 11.2344 15.3656V34.5656C11.2344 36.256 12.6048 37.6264 14.2952 37.6264H33.4952C35.1857 37.6264 36.5561 36.256 36.5561 34.5656V15.3656C36.5561 13.6751 35.1857 12.3047 33.4952 12.3047Z",
    fill: "#A4C639"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 11C20.3284 11 21 10.3284 21 9.5C21 8.67157 20.3284 8 19.5 8C18.6716 8 18 8.67157 18 9.5C18 10.3284 18.6716 11 19.5 11Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9971 11C29.8255 11 30.4971 10.3284 30.4971 9.5C30.4971 8.67157 29.8255 8 28.9971 8C28.1686 8 27.4971 8.67157 27.4971 9.5C27.4971 10.3284 28.1686 11 28.9971 11Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 15.5,
    x2: 36,
    y2: 15.5,
    stroke: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAndriodPlatformIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/andriod_platform_icon.a2b6c240113634b7d003056eaf422193.svg";